<template>
  <div>
    <loading-spinner v-if="loading" />
    <template v-else>
      <b-container>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label class="template-types-tab__label"
                >Supported Template Types</label
              >
              <b-button
                variant="primary"
                class="mr-1"
                :disabled="noFormChanges"
                @click="save()"
              >
                Save
              </b-button>

              <b-form-checkbox-group v-model="selectedTemplateTypes" stacked>
                <b-form-checkbox
                  v-for="templateType in templateTypes"
                  :key="templateType.id"
                  :value="templateType.id"
                >
                  {{ templateType.name }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col md="8" />
        </b-row>
      </b-container>
    </template>
  </div>
</template>

<script>
import $api from '@/services/api';

import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  name: 'TemplateTypesTab',
  components: {
    LoadingSpinner,
  },
  computed: {
    noFormChanges() {
      const selectedTypes = this.selectedTemplateTypes;
      return selectedTypes.sort().join('.') === this.initialData;
    },
    isEnabled() {
      return templateType => {
        return !!templateType.enabled;
      };
    },
  },
  data() {
    return {
      templateTypes: null,
      selectedTemplateTypes: [],
      initialData: null,
      loading: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const templatetypes = await $api.get(
          `/v1/dashboard/templatetypes/chains/${this.$route.params.id}`
        );
        this.templateTypes = templatetypes;
        this.selectedTemplateTypes = this.templateTypes
          .filter(tt => tt.enabled)
          .map(tt => tt.id);
        this.initialData = this.selectedTemplateTypes.sort().join('.');
        this.loading = false;
      } catch (e) {
        alert(`Error retrieving template types: ${JSON.stringify(e)}`);
      }
    },
    async save() {
      this.loading = true;
      try {
        const enabledTemplateTypes = this.templateTypes.map(tt => ({
          ...tt,
          enabled: this.selectedTemplateTypes.includes(tt.id),
        }));
        await $api.put(
          `/v1/dashboard/templatetypes/chains/${this.$route.params.id}`,
          enabledTemplateTypes
        );
        this.initialData = this.selectedTemplateTypes.sort().join('.');
      } catch (e) {
        console.error(e);
        alert(JSON.stringify(e));
      }
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.template-types-tab__label {
  margin-right: 10px;
}
</style>
